import Vue from 'vue'

import Accordion from '@/components/Accordion'
import ApplyNow from '@/components/ApplyNow'
import AjaxForm from '@/components/AjaxForm'
import Modal from '@/components/Modal'
import Masonry from '@/components/Masonry'
import ModalControl from '@/components/ModalControl'
import Gallery from '@/components/Gallery'
import Tabs from '@/components/Tabs'
import TabsContent from '@/components/TabsContent'
import TabsTrigger from '@/components/TabsTrigger'
import GoogleMap from '@/components/GoogleMap'
import Form from '@/components/Form'
import SocialFeed from '@/components/SocialFeed'

Vue.component('accordion', Accordion)
Vue.component('apply-now', ApplyNow)
Vue.component('ajax-form', AjaxForm)
Vue.component('gallery', Gallery)
Vue.component('modal', Modal)
Vue.component('masonry', Masonry)
Vue.component('modal-control', ModalControl)
Vue.component('tabs', Tabs)
Vue.component('tabs-content', TabsContent)
Vue.component('tabs-trigger', TabsTrigger)
Vue.component('google-map', GoogleMap)
Vue.component('vue-form', Form)
Vue.component('vue-social-feed', SocialFeed)
Vue.component('v-style', {
    render: function (createElement) {
      return createElement('style', this.$slots.default)
    }
  });



// WEBPACK FOOTER //
// ./resources/js/components.js